import React from 'react';
import {connect} from 'react-redux';
import {BlockDataForm, SidebarPortal} from '@plone/volto/components';
import {withBlockExtensions} from '@plone/volto/helpers';
import MembersBlockView from './View';
import Schema, {DEFAULT_HEADING} from './EditSchema';

const DEFAULTS = {
    heading: DEFAULT_HEADING,
    items: [],
    register_heading: 'Not yet registered?',
    register_text: 'Create an account to access all member resources and events.',
    signup_label: 'Sign up',
    login_label: 'Log in',
    show_register_box: true,
};

const MembersBlockEdit = (props) => {
    const {data = {}, onChangeBlock, block, selected} = props;

    React.useEffect(() => {
        const next = {...DEFAULTS, ...data};
        if (!Array.isArray(next.items)) next.items = [];

        if (JSON.stringify(next) !== JSON.stringify(data)) {
            onChangeBlock(block, next);
        }
    }, []);

    return (
        <>
            <MembersBlockView data={data} isAuthenticated={false} isEditMode/>

            <SidebarPortal selected={selected}>
                <BlockDataForm
                    title={Schema().title}
                    schema={Schema()}
                    formData={data}
                    onChangeField={(id, value) =>
                        onChangeBlock(block, {...data, [id]: value})
                    }
                />
            </SidebarPortal>
        </>
    );
};

const mapStateToProps = (state) => ({
    isAuthenticated: !!(state.userSession && state.userSession.token),
});

export default withBlockExtensions(connect(mapStateToProps)(MembersBlockEdit));
